import HeaderBackoffice from "component/HeaderBackoffice/HeaderBackoffice";
import { Container } from "@mui/material";
import { Link } from "react-router-dom";

import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const UrlNotFound = (props) => {
  const baseUrl = "https://" + window.location.host;

  const Timer = () => {
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);

      return () => clearInterval(interval);
    }, []);

    useEffect(() => {
      if (countdown === 0) {
        window.location.href = "/backoffice";
      }
    }, [countdown]);

    return (
      <div>
        <p style={{ fontSize: "22px", fontWeight: "700", color: "#0055a6" }}>
          {countdown}
        </p>
      </div>
    );
  };

  return (
    <div>
      <Container fixed>
        <div>
          <HeaderBackoffice backoffice={""} />
        </div>
      </Container>
      <br />

      <Container maxWidth="md">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <h4>
            Este sitio ya no se encuentra disponible, por favor ingresá a:{" "}
          </h4>
          <Link to="/backoffice" style={{ marginLeft: "2%" }}>
            {" "}
            {`${baseUrl}/backoffice`}
          </Link>
        </div>
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>

        <div style={{ marginLeft: "50%", marginTop: "3%" }}>
          <Timer />
        </div>
        <Box sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
      </Container>
    </div>
  );
};
export default UrlNotFound;
